import { setDecimalSeparator } from './userpreference';


// DEPRECATED, use setDecimalSeparator instead
export const numberWithForcedDecimals = (number, options = {}) => {
  const { decimals, addPlus } = options;
  return setDecimalSeparator(number, decimals, { signDisplay: addPlus ? 'always' : 'auto' });
};
